import React from "react";
import "../styles/delete-team-member-modal.css";

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    staffMemberName: string;
    isDeleting: boolean;
};

export default function DeleteTeamMemberModal({
    open,
    onClose,
    onConfirm,
    staffMemberName,
    isDeleting
}: Props) {
    if (!open) return null;

    return (
        <div className="delete-tm-modal-overlay">
            <div className="delete-tm-modal-card">
                <h2 className="delete-tm-modal-title">Delete team member</h2>
                <p className="delete-tm-modal-message">
                    Are you sure you want to delete <strong>{staffMemberName}</strong>? This action cannot be undone.
                </p>
                <div className="delete-tm-modal-actions">
                    <button
                        type="button"
                        className="delete-tm-modal-cancel"
                        onClick={onClose}
                        disabled={isDeleting}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="delete-tm-modal-delete"
                        onClick={onConfirm}
                        disabled={isDeleting}
                    >
                        {isDeleting ? 'Deleting...' : 'Delete'}
                    </button>
                </div>
            </div>
        </div>
    );
}

